var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-header',[(_vm.backLink)?_c('header-link',{directives:[{name:"back-link",rawName:"v-back-link"}],attrs:{"left":true,"edge":true}},[_c('icon',{attrs:{"icon":"back"}}),_vm._v(_vm._s(_vm.backText)+"\n  ")],1):_vm._e(),_vm._v(" "),_c('page-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-9fefbb3c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/header/simple-header.vue
// module id = null
// module chunks = 